import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {FormsModule} from '@angular/forms'
import {ReactiveFormsModule} from '@angular/forms'
import {Routes, RouterModule} from '@angular/router'
import {LoginComponent} from './login'
import {ForgotPasswordComponent} from './forgot-password'
import {ResetPasswordComponent} from './reset-password'
import {LoaderLineModule} from '@app/shared/loader-line/loader-line.module'

const routes: Routes = [
  {
    path: 'login',
    children: [
      {
        path: '',
        component: LoginComponent,
        data: {
          title: 'Login',
        },
      },
      {
        path: 'forgot',
        component: ForgotPasswordComponent,
        data: {
          title: 'Forgot Password',
        },
      },
      {
        path: 'reset',
        component: ResetPasswordComponent,
        data: {
          title: 'Password Reset',
        },
      },
      {
        path: 'reset/:code',
        component: ResetPasswordComponent,
        data: {
          title: 'Password Reset',
        },
      },
      {
        path: '**',
        redirectTo: '/login',
        pathMatch: 'full',
      },
    ],
  },
]

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    LoaderLineModule,
    RouterModule.forChild(routes),
  ],
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
  ],
  exports: [RouterModule],
})
export class AuthModule {}
